import { FormHelperText, withStyles } from '@material-ui/core';
import { variant } from '../../../../materialConfig/customTypography';

export const BaseHelperText = withStyles((theme) => ({
  root: {
    ...variant.caption,
    marginTop: 0,
  },
  error: {
    color: theme.palette.error.main,
  },
}))(FormHelperText);
